module.exports = __webpack_public_path__ + "img/CarrierPak.7a1e28a9.svg";